export default __webpack_public_path__ + "static/media/logo192x192.0b1a91a7.png";